export default [
    {
        key: 'status',
        label: 'Status',
        variant: 'column-md'
    },
    {
        key: 'images',
        label: 'Images',
        variant: 'column-img'
    },
    {
        key: 'sku',
        label: 'SKU',
        sortable: true
    },
    {
        key: 'name',
        label: 'Name',
        sortable: true
    },
    {
        key: 'fnsku',
        label: 'FNSKU',
        sortable: true
    },
    // TODO: Temporarily hidden
    // {
    //     key: 'price',
    //     label: 'Price',
    //     sortable: true,
    //     variant: 'column-md'
    // },
    {
        key: 'value',
        label: 'Value',
        // sortable: true,
        variant: 'column-md'
    },
    // {
    //     key: 'currencyCode',
    //     label: 'Currency',
    //     // sortable: true,
    //     variant: 'column-md'
    // },
    {
        key: 'dateStatus',
        label: 'Date created',
        sortable: true
    },
    {
        key: 'stock.available',
        label: 'Available',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'stock.reserved',
        label: 'Reserved',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'stock.forbidden',
        label: 'Forbidden',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'stock.incoming',
        label: 'Incoming',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'marketplaceRelation.ebayProductId',
        label: 'EAN',
    },
    {
        key: 'marketplaceRelation.amazonProductId',
        label: 'ASIN',
    },
    // TODO: temporarily hidden
    // {
    //     key: 'categories',
    //     label: 'Categories'
    // },
    {
        key: 'manufacturer',
        label: 'Manufacturer',
        sortable: true
    },
    {
        key: 'properties.color',
        label: 'Color',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'properties.size',
        label: 'Size',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'dimensions.wight',
        label: 'Wight',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'dimensions.height',
        label: 'Height',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'dimensions.length',
        label: 'Length',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'dimensions.weight',
        label: 'Weight',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'comments.comment',
        label: 'Comments',
        sortable: true,
        variant: 'column-lg'
    },
    {
        key: 'comments.packingConditions',
        label: 'Packeging',
        sortable: true,
        variant: 'column-lg'
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/inventoryManagement.js